//Include Both Helper File with needed methods
import { postRegister } from "../../../helpers/backend_helper";

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  // apiErrorChange
} from "./reducer";
import axios from "../../../helpers/axiosConfig";
import { setToken } from "../../authSlice";
import { resolveApiMessage } from "../../../helpers/apiMessage";

const extractErrorMessage = (payload: any) =>
  resolveApiMessage(payload, {
    fallbackMessage: "Đăng ký không thành công. Vui lòng thử lại.",
  });

// Is user register successfull then direct plot user in redux.
export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    await axios.get("/sanctum/csrf-cookie", { withCredentials: true });

    await postRegister(user);

    const userResponse = await axios.get("/api/user", { withCredentials: true });
    const data = userResponse?.data ?? userResponse;
    const authUser = data?.user ?? data;

    if (!authUser) {
      dispatch(registerUserFailed("Không thể xác nhận người dùng sau khi đăng ký."));
      return;
    }

    const session = { user: authUser };
    localStorage.setItem("authUser", JSON.stringify(session));
    dispatch(setToken(session));
    dispatch(registerUserSuccessful(authUser));
  } catch (error: any) {
    dispatch(registerUserFailed(extractErrorMessage(error)));
  }
};

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange();
    return response;
  } catch (error) {
    return error;
  }
};

// export const apiError = () => {
//   try {
//     const response = apiErrorChange();
//     return response;
//   } catch (error) {
//     return error;
//   }
// };
